import axios from "axios";

export const getAllDevice = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/device/get-all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener equipos";
  }
};

export const createDeviceService = async (userData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token provided");
  try {
    const { data } = await axios.post(`${API_URL}/api/device`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear equipo");
  }
};

export const updateDeviceService = async (id, userData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(`${API_URL}/api/device/${id}`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al actualizar el equipo";
  }
};

export const deleteDeviceService = async (userId) => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No hay token de autenticación");
  }

  try {
    const response = await axios.delete(`${API_URL}/api/device/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error al marcar el equipo como eliminado";
    throw new Error(errorMessage);
  }
};
